import { useSelector } from 'react-redux';

/**
 * Custom hook to determine if incentives offers are enabled for the current listing.
 *
 * @param {Object} params - Parameters for incentives offer determination
 * @param {Object} params.paymentsDuck - Redux duck for payments
 * @param {string} params.listingId - The listing ID
 * @param {string} params.zip - User's ZIP code
 * @param {string} params.dealerId - Dealer ID
 * @param {string} params.partnerId - Partner ID
 * @param {Object} params.listing - Listing object containing payment services info
 * @param {Object} params.appliedIncentiveIds - Applied incentive IDs by deal type
 * @param {string} params.activeTab - Current active deal type
 * @param {Array} params.availableIncentives - Array of available incentives
 * @param {boolean} params.hasSpecialOffer - Whether listing has special offers
 * @param {string} params.listingType - Type of listing ('new', 'used', etc.)
 * @param {boolean} params.disableIncentives - Whether incentives are disabled
 *
 * @returns {boolean} Whether incentives offers are enabled
 */
const useIncentivesOfferEnabled = _ref => {
  let {
    paymentsDuck,
    listingId,
    zip,
    dealerId,
    partnerId,
    listing,
    appliedIncentiveIds,
    activeTab,
    availableIncentives,
    hasSpecialOffer,
    listingType,
    disableIncentives
  } = _ref;
  const pencilingPayments = useSelector(paymentsDuck.selectors.getPencilingPayments) || {};
  const listingPayments = useSelector(paymentsDuck.selectors.getListingPayments) || {};
  const incentivesUrlFromListing = listing?.paymentServices?.incentivesUrl;
  const hasIncentivesOffers = !!(incentivesUrlFromListing || zip && dealerId && partnerId) && (pencilingPayments[listingId]?.expectAvailableOffers || listingPayments[listingId]?.expectAvailableOffers || appliedIncentiveIds[activeTab]?.length > 0 ||
  // Fallback: if we have incentive IDs from payment calc but no available incentives yet,
  // we should still try to fetch incentive details
  Object.values(appliedIncentiveIds).some(ids => ids?.length > 0) && availableIncentives.length === 0);
  const enabledAmdIncentivesOffers = !hasSpecialOffer && hasIncentivesOffers;
  const isIncentivesOfferEnabled = listingType?.toLowerCase() === 'new' && (hasSpecialOffer || enabledAmdIncentivesOffers) || !disableIncentives;
  return {
    isIncentivesOfferEnabled,
    incentivesUrlFromListing
  };
};
export { useIncentivesOfferEnabled as default };
